import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './notification_watcher_query.module.scss';

type Props = {
  isAlreadyRead: boolean;
};

export const NotificationWatcherQuery: FC<Props> = ({
  children,
  isAlreadyRead,
}) => (
  <span
    className={classNames(styles.container, {
      [styles.new]: !isAlreadyRead,
    })}
  >
    {children}
  </span>
);
